import useCreateContact from "queryHooks/useCreateContact/useCreateContact";

const useCreateContactForm = ({ customerId }) => {
  return useCreateContact(customerId);
};

export default useCreateContactForm;
